import { Button, Center, Img, VStack } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useAuth } from "../../plugins/CookieAuthPlugin";
import { toAbsoluteUrl } from "../../utils/helper";
import { translation } from "./translation";

export default function OutZone() {
   const { user, logout } = useAuth();
   const { pathname } = useLocation();
   const isEn = JSON.parse(localStorage.getItem("isEn")) | false;
   const history = useHistory();
   const previousLocation = pathname.replace("/out-of-zone", "");
   const text = translation(isEn);

   useEffect(() => {
      user && logout();
   }, [user, logout]);

   return (
      <Center h="95vh" bg={`url(${toAbsoluteUrl("/assets/white-bg.svg")}) center / cover no-repeat`}>
         <VStack overflow="hidden" w={{ xl: "30vw", lg: "40vw", md: "50vw", sm: "100%" }} h={{ xl: "80vh", lg: "80vh", md: "80vh", sm: "100%", base: "100%" }} justifyContent="center" px="15px">
            <Center fontSize="170%" textAlign="center" color="red.900" fontWeight={isEn && "bold"} fontFamily={!isEn ? "moul" : "heading"}>
               {text.headerInfo.on}<br />{text.headerInfo.un}
            </Center>
            <Button onClick={() => history.push(previousLocation)} pos={"absolute"} bottom="20px" minW={"300px"} bg={"#663333"} color={"white"} fontFamily={!isEn && "moul"} colorScheme="none">
               {text.back}
               <Img pos={"absolute"} right={"0"} src={toAbsoluteUrl("/assets/flower.svg")} />
               <Img pos={"absolute"} left={"0"} transform={"rotate(180deg)"} src={toAbsoluteUrl("/assets/flower.svg")} />
            </Button>
         </VStack>
      </Center>
   );
}
